import {AfterViewInit, Directive, ElementRef, EventEmitter, Input, OnDestroy, Output} from '@angular/core';

@Directive({
  selector: '[appChatObserver]',
  exportAs: 'intersection',
})
export class ChatObserverDirective implements AfterViewInit, OnDestroy {
  @Input() nowIsStartPosition = false;

  @Output() visible = new EventEmitter<void>();

  private observer: IntersectionObserver | undefined;

  constructor(private element: ElementRef) {}

  ngAfterViewInit() {
    if (this.nowIsStartPosition) {
      this.initObserver();
    }
  }

  initObserver() {
    this.observer = new IntersectionObserver(entries => {
      if (entries[entries.length - 1].isIntersecting === true) {
        this.visible.emit();
      }
    }, {
      threshold: 0.5,
    });

    this.observer.observe(this.element.nativeElement as HTMLElement);
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = undefined;
    }
  }
}
